<template>
  <div class="about-page">
    <!-- Hero Section -->
    <div class="hero-section">
      <div class="hero-background"></div>
      <div class="hero-overlay"></div>
      <v-container class="hero-content">
        <v-row align="center" justify="center" class="fill-height">
          <v-col cols="12" md="10" class="text-center">
            <div class="tagline-container mb-6">
              <p class="tagline text-h5 font-weight-medium text-white">{{ $t('brand.fullName') }}</p>
            </div>
            <p class="mission-statement text-h6 font-weight-regular text-white text-opacity-90  mx-auto mb-4">
              {{ $t('brand.description') }}
            </p>

          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- Company Overview (use shared component) -->
    <CompanyIntro />

    <!-- Core Advantages Section (carousel using v-slide-group) -->
    <v-container class="py-16 core-advantages-section">
      <v-row justify="center">
        <v-col cols="12" class="text-center mb-12">
          <div class="section-title-container">
            <div class="section-title-decoration left"></div>
            <h2 class="text-h3 font-weight-bold primary--text section-title">{{ $t('about.coreAdvantages') }}</h2>
            <div class="section-title-decoration right"></div>
          </div>
        </v-col>
      </v-row>

      <v-row class="core-advantages-row" justify="center">
        <v-col cols="12">
          <div class="advantage-slide-wrapper">
            <v-slide-group ref="slideGroupRef" class="py-6">
              <v-slide-group-item v-for="(item, idx) in advantages" :key="idx" class="pa-3 advantage-slide-item">
                <div class="advantage-card pa-6 advantage-card--compact app-card" elevation="2" hover>
                  <div class="advantage-header mb-4">
                    <div class="advantage-icon-wrapper mb-3">
                      <v-icon size="32" color="primary" class="advantage-icon">{{ item.icon }}</v-icon>
                    </div>
                    <div class="advantage-number-wrapper">
                      <!--                      <div class="advantage-number">{{ item.id }}</div>-->
                    </div>
                    <h3 class="text-h6 primary--text font-weight-bold mb-0 advantage-title">{{ $t(item.titleKey) }}</h3>
                  </div>
                  <v-divider class="mb-4"></v-divider>
                  <p class="text-body-2 text-medium-emphasis advantage-description">
                    {{ $t(item.descKey) }}
                  </p>
                </div>
              </v-slide-group-item>
            </v-slide-group>


          </div>
        </v-col>
      </v-row>
    </v-container>

    <!-- Production Scene Section -->
    <v-container class="py-16 production-scene-section">
      <v-row justify="center">
        <v-col cols="12" class="text-center mb-12">
          <div class="section-title-container">
            <div class="section-title-decoration left"></div>
            <h2 class="text-h3 font-weight-bold primary--text section-title">{{ $t('about.productionScene') }}</h2>
            <div class="section-title-decoration right"></div>
          </div>
        </v-col>
      </v-row>

      <!-- 生产现场图片列表 - 每行4张图片，最多3行 -->
      <v-row dense>
        <!-- 第一行图片 -->
        <v-col cols="12" sm="6" md="3" v-for="item in 12" :key="item">
          <div class="production-image-container">
            <v-img
                :src="`/images/about/creator/img_${item+1}.png`"
                height="100%"
                width="100%"
                cover
                class="production-image"
            >
              <template v-slot:placeholder>
                <div class="d-flex align-center justify-center fill-height">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </div>
              </template>
            </v-img>
          </div>
        </v-col>

      </v-row>

    </v-container>

    <!-- Company Culture Section -->
    <v-container class="py-16 company-culture-section">
      <v-row justify="center">
        <v-col cols="12" class="text-center mb-12">
          <div class="section-title-container">
            <div class="section-title-decoration left"></div>
            <h2 class="text-h3 font-weight-bold primary--text section-title">{{ $t('about.companyCulture') }}</h2>
            <div class="section-title-decoration right"></div>
          </div>
          <p class="culture-subtitle mt-6">{{ $t('about.cultureSubtitle') }}</p>
        </v-col>
      </v-row>

      <!-- Culture Banner with Parallax Effect -->
      <v-row justify="center" align="center" class="mb-16">
        <v-col cols="12">
          <div class="culture-banner">
            <div class="culture-banner-overlay"></div>
            <div class="culture-banner-content">
              <div class="culture-banner-text">
                <h3 class="text-h4 font-weight-bold mb-4">{{ $t('about.cultureBannerTitle') }}</h3>
                <p class="text-h6">{{ $t('about.cultureBannerSubtitle') }}</p>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>

      

      <!-- Mission & Vision Section -->
      <v-container class="mission-vision-section py-12">
        <v-row justify="center" class="mb-8">
          <v-col cols="12" class="text-center">
            <h2 class="text-h3 font-weight-bold primary--text mb-4">{{ $t('about.missionTitle') }} & {{ $t('about.visionTitle') }}</h2>
            <div class="section-divider mx-auto"></div>
        </v-col>
      </v-row>

        <v-row justify="center" align="stretch" class="mb-8">
          <!-- Mission Card -->
          <v-col cols="12" md="5" lg="5" class="px-4">
            <v-card class="mission-vision-card mission-card h-100 app-card" elevation="0" hover>
              <v-card-text class="pa-8 text-center">
                <div class="mission-vision-icon-wrapper mb-6">
                  <div class="mission-vision-icon mission-icon">
                    <v-icon size="48" color="white">mdi-target</v-icon>
            </div>
                </div>
                <h3 class="mission-vision-title mb-4">{{ $t('about.missionTitle') }}</h3>
            <div class="mission-vision-content">
                  <p class="mission-vision-text">{{ $t('about.missionContent') }}</p>
            </div>
              </v-card-text>
            </v-card>
        </v-col>

          <!-- Vision Card -->
          <v-col cols="12" md="5" lg="5" class="px-4">
            <v-card class="mission-vision-card vision-card h-100 app-card" elevation="0" hover>
              <v-card-text class="pa-8 text-center">
                <div class="mission-vision-icon-wrapper mb-6">
                  <div class="mission-vision-icon vision-icon">
                    <v-icon size="48" color="white">mdi-eye-outline</v-icon>
            </div>
                </div>
                <h3 class="mission-vision-title mb-4">{{ $t('about.visionTitle') }}</h3>
            <div class="mission-vision-content">
                  <p class="mission-vision-text">{{ $t('about.visionContent') }}</p>
            </div>
              </v-card-text>
            </v-card>
        </v-col>
      </v-row>
      </v-container>

      <!-- Core Values Detail Cards -->
      <v-container class="core-values-section py-12">
      <v-row justify="center" class="mb-8">
          <v-col cols="12" class="text-center">
            <h2 class="text-h3 font-weight-bold primary--text mb-4">{{ $t('about.coreValuesTitle') }}</h2>
            <div class="section-divider mx-auto"></div>
        </v-col>
      </v-row>

        <v-row justify="center" align="stretch" class="no-gutters">
          <!-- Integrity Card -->
          <v-col cols="6" md="3" class="px-2">
            <div class="app-card value-card h-100 " flat elevation="0" hover>
              <div class="value-card-inner">
                <div class="value-icon-wrapper integrity">
                  <v-icon size="36" color="white">mdi-shield-check</v-icon>
            </div>
            <h4 class="value-title">{{ $t('about.integrityTitle') }}</h4>
                <div class="value-divider"></div>
            <p class="value-desc">{{ $t('about.integrityDesc') }}</p>
          </div>
            </div>
        </v-col>

          <!-- Customer First Card -->
          <v-col cols="6" md="3" class="px-2">
            <v-card class="app-card value-card h-100" flat elevation="0" hover>
              <div class="value-card-inner">
                <div class="value-icon-wrapper customer">
                  <v-icon size="36" color="white">mdi-account-heart</v-icon>
            </div>
            <h4 class="value-title">{{ $t('about.customerFirstTitle') }}</h4>
                <div class="value-divider"></div>
            <p class="value-desc">{{ $t('about.customerFirstDesc') }}</p>
          </div>
            </v-card>
        </v-col>

          <!-- Win-Win Card -->
          <v-col cols="6" md="3" class="px-2">
            <v-card class="app-card value-card h-100" flat elevation="0" hover>
              <div class="value-card-inner">
                <div class="value-icon-wrapper cooperation">
                  <v-icon size="36" color="white">mdi-handshake</v-icon>
            </div>
            <h4 class="value-title">{{ $t('about.cooperationTitle') }}</h4>
                <div class="value-divider"></div>
            <p class="value-desc">{{ $t('about.cooperationDesc') }}</p>
          </div>
            </v-card>
        </v-col>

          <!-- Perseverance Card -->
          <v-col cols="6" md="3" class="px-2">
            <v-card class="app-card value-card h-100" flat elevation="0" hover>
              <div class="value-card-inner">
                <div class="value-icon-wrapper perseverance">
                  <v-icon size="36" color="white">mdi-rocket-launch</v-icon>
            </div>
            <h4 class="value-title">{{ $t('about.perseveranceTitle') }}</h4>
                <div class="value-divider"></div>
            <p class="value-desc">{{ $t('about.perseveranceDesc') }}</p>
          </div>
            </v-card>
        </v-col>
      </v-row>
      </v-container>
    </v-container>

    <!-- Our Story Section -->
    <v-container class="py-16 our-story-section">
      <v-row justify="center">
        <v-col cols="12" class="text-center mb-12">
          <div class="section-title-container">
            <div class="section-title-decoration left"></div>
            <h2 class="text-h3 font-weight-bold primary--text section-title">{{ $t('about.ourStory') }}</h2>
            <div class="section-title-decoration right"></div>
          </div>
        </v-col>
      </v-row>

      <v-row class="story-content-row">
        <v-col cols="12" lg="6" class="pr-lg-8">
          <div class="story-intro-container">
            <p class="story-intro-text">
              {{ $t('about.ourStoryIntro') }}
            </p>

            <h3 class="text-h5 font-weight-bold mt-12 mb-6 primary--text">{{ $t('about.ourTeamComposition') }}</h3>

            <div class="team-types-container">
              <div v-for="(member, index) in teamTypes" :key="index" class="team-type-item">
                <div class="team-type-icon-wrapper">
                  <v-icon color="white" size="24">{{ member.icon }}</v-icon>
                </div>
                <div class="team-type-content">
                  <p class="team-type-text">{{ $t(`about.teamType${index + 1}`) }}</p>
                </div>
              </div>
            </div>
          </div>
        </v-col>

        <v-col cols="12" lg="6" class="pl-lg-8 mt-8 mt-lg-0">
          <div class="story-mission-container">
            <p class="story-mission-text mb-4">
              {{ $t('about.ourStoryMission1') }}
            </p>
            <p class="story-mission-text mb-4">
              {{ $t('about.ourStoryMission2') }}
            </p>

            <p class="story-mission-text mb-4">
              {{ $t('about.ourStoryMission3') }}
            </p>
            <div class="story-quote-container mt-8">
              <div class="quote-icon-wrapper mb-4">
                <v-icon color="primary" size="32">mdi-format-quote-open</v-icon>
              </div>
              <p class="story-quote-text">
                {{ $t('about.ourStoryQuote') }}
              </p>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script setup lang="ts">
import {ref, onMounted, nextTick, onBeforeUnmount} from 'vue'
import {useI18n} from 'vue-i18n'
import CountTo from 'vue3-count-to'
import CompanyIntro from '@/components/CompanyIntro.vue'

const {t} = useI18n()

// 核心优势图标
const getAdvantageIcon = (index: number) => {
  const icons = {
    1: 'mdi-lightbulb-on',        // 智慧农业
    2: 'mdi-cog',                 // 技术领先
    3: 'mdi-factory',             // 生产基地
    4: 'mdi-earth',               // 全球市场
    5: 'mdi-map-marker',          // 自贸区区位
    6: 'mdi-handshake',           // 全球化服务能力
  }
  return icons[index as keyof typeof icons]
}


const teamTypes = [
  {icon: 'mdi-school'},
  {icon: 'mdi-tractor'},
  {icon: 'mdi-account-group'}
]

// 优势项数据（用于轮播）
const advantages = [
  {id: 1, icon: 'mdi-lightbulb-on', titleKey: 'about.advantage1', descKey: 'about.advantage1Description'},
  {id: 2, icon: 'mdi-cog', titleKey: 'about.advantage2', descKey: 'about.advantage2Description'},
  {id: 3, icon: 'mdi-factory', titleKey: 'about.advantage3', descKey: 'about.advantage3Description'},
  {id: 4, icon: 'mdi-earth', titleKey: 'about.advantage4', descKey: 'about.advantage4Description'},
  {id: 5, icon: 'mdi-map-marker', titleKey: 'about.advantage5', descKey: 'about.advantage5Description'},
  {id: 6, icon: 'mdi-handshake', titleKey: 'about.advantage6', descKey: 'about.advantage6Description'},
]

const slideGroupRef = ref<InstanceType<any> | null>(null)
let autoPlayTimer: number | null = null

const scrollPrev = async () => {
  await nextTick()
  const el = getSlideGroupContent()
  if (!el) return
  smoothScrollBy(el, -Math.round(el.clientWidth * 0.6))
}

const scrollNext = async () => {
  await nextTick()
  const el = getSlideGroupContent()
  if (!el) return
  smoothScrollBy(el, Math.round(el.clientWidth * 0.6))
}

function getSlideGroupContent() {
  // v-slide-group 渲染出一个滚动容器 .v-slide-group__content
  const root = (slideGroupRef as any)?.value?.$el || null
  if (!root) return null
  return root.querySelector('.v-slide-group__content')
}

function smoothScrollBy(container: HTMLElement, delta: number) {
  const start = container.scrollLeft
  const target = start + delta
  const duration = 420
  const startTime = performance.now()

  function step(now: number) {
    const t = Math.min(1, (now - startTime) / duration)
    const eased = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t
    container.scrollLeft = Math.round(start + (target - start) * eased)
    if (t < 1) requestAnimationFrame(step)
  }

  requestAnimationFrame(step)
}

// 自动播放（可选），鼠标悬停时暂停
function startAutoPlay() {
  stopAutoPlay()
  autoPlayTimer = window.setInterval(() => {
    const el = getSlideGroupContent()
    if (!el) return
    smoothScrollBy(el, Math.round(el.clientWidth * 0.6))
  }, 4500)
}

function stopAutoPlay() {
  if (autoPlayTimer) {
    clearInterval(autoPlayTimer)
    autoPlayTimer = null
  }
}

onMounted(() => {
  // 等待 DOM 完成
  nextTick(() => {
    const el = getSlideGroupContent()
    if (!el) return
    // 鼠标悬停时暂停自动播放
    el.addEventListener('mouseenter', stopAutoPlay)
    el.addEventListener('mouseleave', startAutoPlay)
    startAutoPlay()
  })
})

onBeforeUnmount(() => {
  stopAutoPlay()
})
</script>

<style scoped>
.about-page {
  background-color: #ffffff;
}

.v-container:not(.fluid) {
  max-width: 1400px !important;
}

/* Hero Section Styles */
.hero-section {
  position: relative;
  height: 600px;
  width: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.hero-background {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  height: 100%;
  min-width: 100%;
  width: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.hero-background::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100vw;
  height: 100%;
  background: url('/images/about/about2.jpg') no-repeat center center;
  background-size: cover;
  z-index: 1;
}

/* 两侧模糊效果 */
.hero-background::after {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 120vw; /* 比实际宽度多20%，确保两侧有足够空间 */
  height: 100%;
  background: url('/images/about/about.jpg') no-repeat center center;
  background-size: cover;
  filter: blur(20px) brightness(0.8);
  z-index: 0;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
      to bottom,
      rgba(27, 77, 62, 0.25) 0%,
      rgba(27, 77, 62, 0.35) 100%
  );
  z-index: 2;
}

.hero-content {
  position: relative;
  z-index: 3;
  height: 100%;
}

.text-opacity-80 {
  opacity: 0.9;
}

/* 新增样式 */
.brand-name {
  font-size: 3.5rem;
  margin-bottom: 1rem;
  letter-spacing: 1px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.tagline-container {
  margin-bottom: 1.5rem;
}

.tagline {
  font-size: 1.8rem;
  line-height: 1.6;
  letter-spacing: 0.5px;
  font-weight: 500;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
}

.mission-statement {
  font-size: 1.5rem;
  line-height: 1.8;
  margin-bottom: 2rem;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
}

.company-english {
  margin-bottom: 1rem;
}

.company-english h2 {
  font-size: 2.8rem;
  letter-spacing: 1px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.company-description {
  font-size: 1.2rem;
  line-height: 1.8;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
}

/* 添加微动画效果 */
@keyframes subtle-zoom {
  0% {
    transform: translateX(-50%) scale(1);
  }
  50% {
    transform: translateX(-50%) scale(1.05);
  }
  100% {
    transform: translateX(-50%) scale(1);
  }
}

.hero-background::before {
  animation: subtle-zoom 20s infinite ease-in-out;
}

/* Core Values Styles */
.value-card {
  position: relative;
  height: 100%;
}



/* ===== Contact.vue Core Values styles migrated ===== */
.value-card-inner {
  background-color: white;
  border-radius: 16px;
  padding: 30px 25px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
  overflow: hidden;
  transition: all 0.4s ease;
  z-index: 1;
}



.value-icon-wrapper {
  width: 80px;
  height: 80px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 25px;
  transition: all 0.4s ease;
  box-shadow: 0 8px 20px rgba(3, 55, 135, 0.2);
  transform: rotate(45deg);
}

.value-icon-wrapper .v-icon { transform: rotate(-45deg); }

.value-card:hover .value-icon-wrapper {
  transform: rotate(0deg);
  border-radius: 50%;
}

.value-card:hover .value-icon-wrapper .v-icon {
  transform: rotate(0deg) scale(1.2);
}

.value-icon-wrapper.integrity {
  background: linear-gradient(135deg, rgba(3, 55, 135, 0.9) 0%, rgba(12, 72, 162, 0.9) 100%);
}
.value-icon-wrapper.customer {
  background: linear-gradient(135deg, rgba(3, 55, 135, 0.9) 20%, rgba(3, 55, 135, 0.8) 100%);
}
.value-icon-wrapper.cooperation {
  background: linear-gradient(135deg, rgba(12, 72, 162, 0.9) 0%, rgba(22, 71, 148, 0.9) 100%);
}
.value-icon-wrapper.perseverance {
  background: linear-gradient(135deg, rgba(22, 71, 148, 0.9) 0%, rgba(3, 55, 135, 0.8) 100%);
}

.value-title {
  color: #033787;
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 15px;
  letter-spacing: 0.5px;
}

.value-divider {
  width: 40px;
  height: 3px;
  background: linear-gradient(90deg, rgba(3, 55, 135, 0.3), rgba(12, 72, 162, 0.3));
  margin: 0 auto 15px;
  border-radius: 2px;
  transition: all 0.3s ease;
}
.value-card:hover .value-divider {
  width: 60px;
  background: linear-gradient(90deg, rgba(3, 55, 135, 0.8), rgba(12, 72, 162, 0.8));
}

.value-desc {
  color: #555;
  font-size: 1rem;
  line-height: 1.6;
  flex-grow: 1;
}
/* ===== end Contact styles ===== */

/* Stats Section Styles */
.stats-section {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  position: relative;
  overflow: hidden;
  padding: 4rem 0;
}

.stats-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('/images/about/company.jpg') center/cover no-repeat;
  opacity: 0.03;
  z-index: 1;
}

.stat-item {
  position: relative;
  z-index: 2;
  padding: 2rem;
  transition: transform 0.3s ease;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 16px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.stat-item:hover {
  transform: translateY(-5px);
  background: rgba(255, 255, 255, 0.9);
}

.stat-number {
  font-size: 3.5rem;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 1rem;
  color: var(--v-primary-base);
  display: flex;
  align-items: center;
  justify-content: center;
}

.stat-number .suffix {
  font-size: 2.5rem;
  margin-left: 4px;
}

.stat-label {
  font-size: 1.1rem;
  color: #1e293b;
  font-weight: 500;
  margin: 0;
}

/* Team Section Styles */
.team-card {
  background: transparent;
  transition: all 0.3s ease;
  overflow: visible;
}

.team-image-wrapper {
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  aspect-ratio: 1;
}

.team-member-image {
  transition: all 0.5s ease;
  height: 100% !important;
  object-fit: cover;
}

.team-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
      to bottom,
      rgba(27, 77, 62, 0) 0%,
      rgba(27, 77, 62, 0.9) 100%
  );
  opacity: 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 2rem;
  transition: all 0.3s ease;
}

.social-links {
  transform: translateY(20px);
  transition: all 0.3s ease;
}

.team-image-wrapper:hover {
  transform: translateY(-10px);
}

.team-image-wrapper:hover .team-member-image {
  transform: scale(1.05);
}

.team-image-wrapper:hover .team-overlay {
  opacity: 1;
}

.team-image-wrapper:hover .social-links {
  transform: translateY(0);
}

.team-card v-card-text {
  position: relative;
  z-index: 1;
  background: white;
  border-radius: 16px;
  margin-top: -60px;
  margin-left: 20px;
  margin-right: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}


/* Section Title Styling */
.section-title-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  position: relative;
}

.section-title {
  position: relative;
  padding: 0 20px;
  margin-bottom: 15px;
  display: inline-block;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background-color: rgb(var(--v-theme-primary));
  border-radius: 2px;
}

.section-title-decoration {
  height: 2px;
  background: linear-gradient(90deg, rgba(var(--v-theme-primary), 0) 0%, rgba(var(--v-theme-primary), 0.7) 100%);
  flex: 1;
  max-width: 100px;
  margin: 0 15px;
}

.section-title-decoration.left {
  background: linear-gradient(90deg, rgba(var(--v-theme-primary), 0) 0%, rgba(var(--v-theme-primary), 0.7) 100%);
}

.section-title-decoration.right {
  background: linear-gradient(90deg, rgba(var(--v-theme-primary), 0.7) 0%, rgba(var(--v-theme-primary), 0) 100%);
}

@media (max-width: 960px) {
  .company-overview-col {
    padding-left: 1rem;
    padding-right: 1rem;
    margin-top: 2rem;
  }
}

/* Core Advantages Section Styles */


.advantage-card {
  border-radius: 12px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 18px rgba(27, 77, 62, 0.07);
  display: flex;
  flex-direction: column;

  min-height: 240px;
  justify-content: center;
  align-items: center;
  margin-bottom: 0;
}

/* 更紧凑的卡片变体用于轮播，减少高度并限制最大宽度 */
.advantage-card--compact {
  min-height: 180px;
  width: 396px;
  padding: 28px !important;
  margin: 8px;
  box-sizing: border-box;
}



.advantage-header {
  position: relative;
  text-align: center;
}

.advantage-icon-wrapper {
  width: 70px;
  height: 70px;
  margin: 0 auto;
  background: rgba(var(--v-theme-primary), 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.advantage-card:hover .advantage-icon-wrapper {
  transform: scale(1.1);
  background: rgba(var(--v-theme-primary), 0.2);
}

.advantage-icon {
  font-size: 32px;
  transition: all 0.3s ease;
}

.advantage-card:hover .advantage-icon {
  transform: rotate(10deg);
}

.advantage-number-wrapper {
  position: absolute;
  top: -10px;
  right: -10px;
  z-index: 2;
}

.advantage-number {
  width: 32px;
  height: 32px;
  background: rgb(var(--v-theme-primary));
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  font-weight: bold;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
}

.advantage-title {
  margin-top: 1rem;
  text-align: center;
  font-size: 1.2rem;
  line-height: 1.4;
  min-height: 2.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.advantage-description {
  line-height: 1.8;
  color: rgba(0, 0, 0, 0.7);
  text-align: center;
}

/* Production Scene Section Styles */
.production-scene-section {
  background-color: #ffffff;
}

/* Company Culture Section Styles */
.company-culture-section {
  background-color: #f8f9fa;
  padding-top: 80px;
  padding-bottom: 80px;
  position: relative;
  overflow: hidden;
}

.company-culture-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url('/images/about/img.png') no-repeat center center;
  background-size: cover;
  opacity: 0.03;
  z-index: 0;
}

.culture-subtitle {
  font-size: 1.2rem;
  color: #666;
  max-width: 700px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

/* Culture Banner */
.culture-banner {
  position: relative;
  height: 280px;
  border-radius: 16px;
  overflow: hidden;
  background: url('/images/about/production-1.jpg') no-repeat center center;
  background-size: cover;
  background-attachment: fixed;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  margin-bottom: 40px;
}

.culture-banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(3, 55, 135, 0.85) 0%, rgba(12, 72, 162, 0.85) 100%);
  z-index: 1;
}

.culture-banner-content {
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.culture-banner-text {
  text-align: center;
  color: white;
}

.culture-banner-text h3 {
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  letter-spacing: 2px;
}

.culture-banner-text p {
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  letter-spacing: 1px;
}

/* Hexagon Core Values */
.core-values-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  gap: 2.5rem;
  padding: 2rem 1rem;
}


.core-value-hexagon {
  position: relative;
  width: 200px;
  height: 200px;
  margin: 0;
  cursor: pointer;
  transition: all 0.4s ease;
  flex: 0 0 auto;
}

.hexagon-inner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(3, 55, 135, 0.85) 0%, rgba(12, 72, 162, 0.85) 100%);
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.4s ease;
  border: 2px solid rgba(255, 255, 255, 0.2);
}

.hexagon-content {
  color: white;
  text-align: center;
  padding: 15px;
  transform: scale(0.9);
  transition: transform 0.3s ease;
}

.core-value-hexagon:hover .hexagon-inner {
  transform: rotate(15deg);
  background: linear-gradient(135deg, rgba(3, 55, 135, 0.9) 0%, rgba(42, 107, 75, 0.9) 100%);
}

.core-value-hexagon:hover .hexagon-content {
  transform: scale(1) rotate(-15deg);
}

.hexagon-1 .hexagon-inner {
  background: linear-gradient(135deg, rgba(3, 55, 135, 0.85) 0%, rgba(12, 72, 162, 0.85) 100%);
}

.hexagon-2 .hexagon-inner {
  background: linear-gradient(135deg, rgba(3, 55, 135, 0.85) 20%, rgba(3, 55, 135, 0.75) 100%);
}

.hexagon-3 .hexagon-inner {
  background: linear-gradient(135deg, rgba(12, 72, 162, 0.85) 0%, rgba(22, 71, 148, 0.85) 100%);
}

.hexagon-4 .hexagon-inner {
  background: linear-gradient(135deg, rgba(22, 71, 148, 0.85) 0%, rgba(3, 55, 135, 0.75) 100%);
}

/* Mission & Vision Section - Card Style */
.mission-vision-section {
  border-radius: 16px;
  margin: 2rem 0;
  position: relative;
  overflow: hidden;
}



.mission-vision-card {
  border-radius: 16px;
  transition: all 0.4s ease;
  position: relative;
  z-index: 1;
}



.mission-vision-icon-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.mission-vision-icon {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  transition: all 0.4s ease;
}

.mission-icon {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
}

.vision-icon {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
}

.mission-vision-card:hover .mission-vision-icon {
  transform: scale(1.1) rotate(10deg);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.2);
}

.mission-vision-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: #1565c0;
  margin-bottom: 16px;
  letter-spacing: 0.5px;
}

.mission-vision-text {
  font-size: 1.1rem;
  line-height: 1.7;
  color: #424242;
  margin: 0;
}

/* Core Values Section - Card Style */
.core-values-section {
  border-radius: 16px;
  margin: 2rem 0;
  position: relative;
}

.value-card {
  border-radius: 16px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 18px rgba(27, 77, 62, 0.07);
  min-height: 240px;
  display: flex;
  flex-direction: column;
}





.value-icon-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 1;
  flex-shrink: 0;
}

.section-divider {
  width: 100px;
  height: 4px;
  background: linear-gradient(90deg, #1976d2 0%, #1565c0 100%);
  border-radius: 2px;
}

/* Core Values Section */
.values-divider {
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #033787 0%, #0c48a2 100%);
  border-radius: 2px;
}

.value-item {
  text-align: center;
  padding: 20px 16px;
  transition: all 0.3s ease;
  position: relative;
  top: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.value-item:hover {
  top: -8px;
}

.value-icon-circle {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  transition: all 0.4s ease;
  box-shadow: 0 4px 16px rgba(25, 118, 210, 0.15);
  flex-shrink: 0;
}

.value-icon-circle.integrity {
  background: linear-gradient(135deg, #1976d2 0%, #42a5f5 100%);
}

.value-icon-circle.customer {
  background: linear-gradient(135deg, #1565c0 0%, #2196f3 100%);
}

.value-icon-circle.cooperation {
  background: linear-gradient(135deg, #0d47a1 0%, #1976d2 100%);
}

.value-icon-circle.perseverance {
  background: linear-gradient(135deg, #2196f3 0%, #1565c0 100%);
}

.value-item:hover .value-icon-circle {
  transform: scale(1.1) rotate(5deg);
  box-shadow: 0 8px 24px rgba(25, 118, 210, 0.25);
}

.value-title {
  color: #1976d2;
  font-size: 1.1rem;
  font-weight: 700;
  margin-bottom: 8px;
  letter-spacing: 0.3px;
  line-height: 1.3;
}

.value-desc {
  color: #666;
  font-size: 0.9rem;
  line-height: 1.5;
  opacity: 0.9;
  margin: 0;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

/* Responsive Styles for Culture Section */
@media (max-width: 960px) {
  .culture-banner {
    height: 220px;
    background-attachment: scroll;
  }

  .core-value-hexagon {
    width: 200px;
    height: 200px;
    margin: 0;
    flex: 0 0 calc(50% - 0.75rem);
    max-width: 200px;
  }
  
  .core-values-container {
    gap: 1.5rem;
    max-width: 100%;
    padding: 1.5rem 1rem;
    justify-content: space-around;
  }

  .value-icon-circle {
    width: 70px;
    height: 70px;
    margin-bottom: 16px;
  }

  .value-icon-circle .v-icon {
    font-size: 28px !important;
  }

  .value-title {
    font-size: 1.1rem !important;
    margin-bottom: 8px !important;
  }

  .value-desc {
    font-size: 0.9rem !important;
    line-height: 1.4;
  }
}

@media (max-width: 768px) and (min-width: 601px) {
  .core-value-hexagon {
    width: 200px;
    height: 200px;
    flex: 0 0 calc(50% - 0.75rem);
    max-width: 200px;
  }
  
  .core-values-container {
    gap: 1.5rem;
    padding: 1.5rem 1rem;
  }
}

@media (max-width: 600px) {
  .culture-banner {
    height: 180px;
  }

  .culture-banner-text h3 {
    font-size: 1.5rem !important;
  }

  .culture-banner-text p {
    font-size: 1rem !important;
  }

  .core-value-hexagon {
    width: 200px;
    height: 200px;
    margin: 0;
    flex: 0 0 auto;
    max-width: none;
    border-radius: 0;
    background: none;
    box-shadow: none;
    padding: 0;
    clip-path: none;
    transition: all 0.4s ease;
    border: none;
  }

  .core-value-hexagon:hover {
    transform: translateY(-8px) scale(1.05);
  }
  
  .core-values-container {
    gap: 1.2rem;
    padding: 1rem;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .hexagon-inner {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.4s ease;
    border: 2px solid rgba(255, 255, 255, 0.2);
  }

  .hexagon-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
    text-align: center;
    color: white;
    z-index: 2;
  }

  .hexagon-content .v-icon {
    font-size: 42px !important;
    color: white;
    margin-bottom: 16px;
  }

  .hexagon-content h4 {
    font-size: 1.3rem !important;
    font-weight: 600;
    color: white;
    margin: 0;
    line-height: 1.3;
  }

  /* 不同价值观的六边形背景颜色 */
  .hexagon-1 .hexagon-inner {
    background: linear-gradient(135deg, #1976d2 0%, #42a5f5 100%);
  }

  .hexagon-2 .hexagon-inner {
    background: linear-gradient(135deg, #1565c0 0%, #2196f3 100%);
  }

  .hexagon-3 .hexagon-inner {
    background: linear-gradient(135deg, #0d47a1 0%, #1976d2 100%);
  }

  .hexagon-4 .hexagon-inner {
    background: linear-gradient(135deg, #2196f3 0%, #1565c0 100%);
  }
}

@media (max-width: 480px) {
  .core-value-hexagon {
    width: 200px;
    height: 200px;
    flex: 0 0 auto;
  }
  
  .core-values-container {
    gap: 1.5rem;
    padding: 1rem;
    flex-direction: column;
  }

  .hexagon-content .v-icon {
    font-size: 38px !important;
  }

  .hexagon-content h4 {
    font-size: 1.2rem !important;
  }

  .value-icon-circle {
    width: 60px;
    height: 60px;
    margin-bottom: 12px;
  }

  .value-icon-circle .v-icon {
    font-size: 24px !important;
  }

  .value-title {
    font-size: 1rem !important;
    margin-bottom: 6px !important;
  }

  .value-desc {
    font-size: 0.85rem !important;
  }
}

.production-image-container {
  position: relative;
  overflow: hidden;
  cursor: pointer;
  height: 250px;
}

.production-image {
  transition: transform 0.4s ease;
}

.production-image-container:hover .production-image {
  transform: scale(1.1);
}

.production-video {
  width: 100%;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

/* Our Story Section Styles */
.our-story-section {
  background-color: #ffffff;
  position: relative;
}

.story-content-row {
  max-width: 1200px;
  margin: 0 auto;
}

.story-intro-container, .story-mission-container {
  height: 100%;
  padding: 20px;
}

.story-intro-text {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #333;
  margin-bottom: 30px;
  text-align: justify;
}

.team-types-container {
  margin-top: 20px;
}

.team-type-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 10px;
  transition: all 0.3s ease;
}

.team-type-item:hover {
  transform: translateX(10px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.team-type-icon-wrapper {
  min-width: 40px;
  height: 40px;
  background-color: #033787;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
}

.team-type-content {
  flex: 1;
}

.team-type-text {
  margin: 0;
  font-size: 1rem;
  line-height: 1.6;
  color: #333;
}

.story-mission-text {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #333;
  text-align: justify;
}

.story-quote-container {
  background-color: #f8f9fa;
  padding: 25px;
  border-radius: 10px;
  border-left: 4px solid #033787;
  position: relative;
}

.quote-icon-wrapper {
  display: flex;
  justify-content: center;
}

.story-quote-text {
  font-size: 1.2rem;
  font-style: italic;
  color: #555;
  text-align: center;
  margin: 0;
  line-height: 1.6;
}

/* Responsive Styles */
@media (max-width: 960px) {
  .hero-section {
    height: 500px;
  }

  .text-h2 {
    font-size: 2.5rem !important;
  }

  .text-h3 {
    font-size: 2rem !important;
  }

  .stat-number {
    font-size: 3rem;
  }

  .stat-number .suffix {
    font-size: 2rem;
  }

  .stat-label {
    font-size: 1rem;
  }

  .team-image-wrapper {
    height: 350px;
  }
}

@media (max-width: 600px) {
  .hero-section {
    height: 400px;
  }

  .text-h2 {
    font-size: 2rem !important;
  }

  .text-h3 {
    font-size: 1.75rem !important;
  }

  .text-h5 {
    font-size: 1.25rem !important;
  }

  .story-intro-text, .story-mission-text {
    font-size: 1rem;
    line-height: 1.6;
  }

  .team-type-item {
    padding: 12px;
  }

  .team-type-icon-wrapper {
    min-width: 36px;
    height: 36px;
  }

  .team-type-text {
    font-size: 0.95rem;
  }

  .story-quote-text {
    font-size: 1.1rem;
  }

  .section-title-decoration {
    max-width: 60px;
  }

  .company-intro-container {
    padding: 30px 20px;
  }

  .international-title {
    font-size: 1.75rem;
  }

  .international-title-underline {
    margin-bottom: 30px;
  }

  .international-icon-wrapper {
    width: 70px;
    height: 70px;
  }

  .international-card {
    padding: 25px 15px;
  }

  .international-card-title {
    font-size: 1.2rem;
    margin-bottom: 12px;
  }

  .international-card-text {
    font-size: 0.95rem;
  }
}

.value-card {
  text-align: center;
}

.value-icon-wrapper {
  margin: 1.5rem auto ;
}

.stat-item {
  padding: 1.5rem;
}

.stat-number {
  font-size: 2.5rem;
}

.stat-number .suffix {
  font-size: 1.8rem;
}

.stat-label {
  font-size: 0.9rem;
}

.team-image-wrapper {
  height: 300px;
}

/* Responsive Adjustments */
@media (max-width: 960px) {
  .mission-card, .value-card {
    margin-bottom: 1.5rem;
  }

  .mission-icon-wrapper, .value-icon-wrapper {
    width: 72px;
    height: 72px;
  }

  .story-list .v-list-item {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .story-list .v-list-item .v-icon {
    margin-right: 0 !important;
    margin-bottom: 0.5rem;
  }
}

.core-advantages-row {
  margin-left: 0;
  margin-right: 0;
  row-gap: 24px;
  column-gap: 16px;
}

/* v-slide-item 宽度控制，配合不同屏幕展示合适数量 */
.advantage-slide-wrapper {
  position: relative;
}

.advantage-slide-item {
  display: inline-block;
  vertical-align: top;
  width: 310px; /* 进一步减小宽度以防第四张卡露出 */
  margin: 0 12px;
  min-height: 400px;
}

@media (min-width: 1400px) {
  .advantage-slide-item {
    width: 340px; /* 大屏略宽但仍保证三个卡片可见 */
    overflow: hidden;
  }

  .advantage-card--compact {
    max-width: 760px;
  }
}

@media (max-width: 960px) {
  .advantage-slide-item {
    width: calc(100% - 48px); /* 手机上显示单个卡片并保留左右间距 */
  }

  .advantage-card--compact {
    min-height: 160px;
    padding: 20px !important;
  }
}

/* 自定义导航按钮 */
.adv-nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 48px;
  height: 96px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(27, 77, 62, 0.06);
  box-shadow: 0 6px 18px rgba(27, 77, 62, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.22s ease, box-shadow 0.22s ease, background 0.22s ease;
}

.adv-nav-btn:hover {
  transform: translateY(-50%) scale(1.03);
  box-shadow: 0 10px 28px rgba(27, 77, 62, 0.12);
}

.adv-nav-btn--left {
  left: 8px
}

.adv-nav-btn--right {
  right: 8px
}

@media (max-width: 960px) {
  .adv-nav-btn {
    display: none
  }
}

/* 隐藏 v-slide-group 的原生箭头，使用自定义按钮 */
.advantage-slide-wrapper .v-slide-group__prev,
.advantage-slide-wrapper .v-slide-group__next,
.advantage-slide-wrapper .v-btn.v-slide-group__prev,
.advantage-slide-wrapper .v-btn.v-slide-group__next,
.advantage-slide-wrapper .v-slide-group__controls {
  display: none !important;
}

@media (max-width: 960px) {
  .core-advantages-row {
    row-gap: 12px;
    column-gap: 0;
  }

  .advantage-card {
    min-height: 160px;
  }
}

/* Mobile Layout - Single Column for Core Values Cards */
@media (max-width: 768px) {
  /* Force single column layout for Core Values cards on mobile and tablet */
  .core-values-section .v-col.col-6,
  .core-values-section .v-col[class*="col-6"],
  .core-values-section .col-6 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    width: 100% !important;
  }
  
  .core-values-section .v-col {
    padding: 0.5rem !important;
  }
  
  .core-values-section .v-row {
    margin: 0 !important;
  }
  
  .value-card {
    margin-bottom: 1.5rem !important;
  }
}

@media (max-width: 480px) {
  .value-card {
    margin-bottom: 1.2rem !important;
  }
  
  .value-icon-wrapper {
    width: 64px !important;
    height: 64px !important;
    margin-bottom: 1rem !important;
  }
  
  .value-icon-circle {
    width: 64px !important;
    height: 64px !important;
  }
  
  .value-icon-circle .v-icon {
    font-size: 24px !important;
  }
  
  .value-title {
    font-size: 1.1rem !important;
  }
  
  .value-desc {
    font-size: 0.9rem !important;
  }
}
</style>
